import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import PDFViewer from "components/PDFViewer";
import { useTranslation } from "react-i18next";

const ShowPreviewModal: FC<Props> = ({ blob, toggle }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <PDFViewer
          file={blob}
          title={t("common.preview")}
          showCloseButton={true}
          onCloseButton={toggle}
        />
      </div>
    </div>
  );
};

export default ShowPreviewModal;
